import { GlobalConstants } from "../../../common/constants/global.constant";

export const osNameConstant = [
  {
    name: GlobalConstants.WIN_10_HOME_OS_TEXT,
    nameInEng: 'Windows* 10 Home'
  },
  {
    name: GlobalConstants.WIN_10_PRO_OS_TEXT,
    nameInEng: 'Windows* 10 Pro'
  },
  {
    name: GlobalConstants.WIN_11_HOME_OS_TEXT,
    nameInEng: 'Windows* 11 Home'
  },
  {
    name: GlobalConstants.WIN_11_PRO_OS_TEXT,
    nameInEng: 'Windows* 11 Pro'
  },
  {
    name: GlobalConstants.WIN_10_HOMEINS_OS_TEXT,
    nameInEng: 'Windows* 10 Home in S mode'
  },
  {
    name: GlobalConstants.WIN_11_HOMEINS_OS_TEXT,
    nameInEng: 'Windows* 11 Home in S mode'
  },
  {
    name: GlobalConstants.CHROME_OS_TEXT,
    nameInEng: 'Chrome* OS'
  }
]